import domContentLoaded from 'dom-content-loaded';
import $, { each } from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel';

export default () => {
	domContentLoaded(() => {
		const $carousels = $('.js_carousel');
		const $contorols = $('.js_carousel_control');
		$carousels.each((index, carousel) => {
			$(carousel).slick({
				arrows: true,
				dots: true,
				appendDots: $contorols.eq(index),
				// appendArrows: $contorols.eq(index),
				prevArrow: '<button class="js_carousel_prev_arrow"></button>',
				nextArrow: '<button class="js_carousel_next_arrow"></button>',
			});
		});
	});
};
